<template>
  <el-dialog :title='dialogTitle' :visible.sync='dialogVisible' :close-on-click-modal='false'
             @close='dialogClose' width='1000px'>
    <el-form v-loading='formLoading' :model='form' label-width='140px' label-position='right'
             ref='ruleForm'
             class='settlement-form mt20'>
      <div-border label='基本信息'>
        <el-row :gutter='10'>
          <el-col :span='12'>
            <el-form-item label='委托商：'>
              <span>{{ form.consignorName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='业务编号：'>
              <span>{{ form.businessNo }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='时间：'>
              <span>{{ form.years }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='业务单位：'>
              <span>{{ form.businessUnit }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='业务类型：'>
              <span>{{ form.businessType }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='业务板块：'>
              <span>{{ form.businesSegment }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='联运类型：'>
              <span>{{ form.transportType }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='货类：'>
              <span>{{ form.goods }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='业务来源：'>
              <span>{{ form.businessSource }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='客户行业：'>
              <span>{{ form.customerIndustry }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='是否固定资产业务：'>
              <span>{{ form.fixedBusiness }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='计量单位：'>
              <span>{{ form.meteringCompany }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='下包属性：'>
              <span>{{ form.packageAttribute }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label='备注：'>
              <span>{{ form.remarks }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </div-border>

      <div-border label='运段信息'>
        <div class='yang' v-for='(item, index) in form.transportSectionList' :key='index'>
          <el-row :gutter='10'>
            <el-col :span='12'>
              <el-form-item label='业务量：'>
                <span>{{ item.businessVolume }}</span>
              </el-form-item>
            </el-col>
            <el-col :span='12'>
              <el-form-item label='重量：'>
                <span>{{ item.weight }}</span>
              </el-form-item>
            </el-col>
            <el-col :span='12'>
              <el-form-item label='不含税收入：'>
                <span>{{ item.taxExcluded }}</span>
              </el-form-item>
            </el-col>
            <el-col :span='12'>
              <el-form-item label='物流工具：'>
                <span>{{ item.logisticsTools }}</span>
              </el-form-item>
            </el-col>
            <el-col :span='12'>
              <el-form-item label='物流方式：'>
                <span>
                  {{ item.logisticsMode === 1 ? '江运' : item.logisticsMode === 0 ? '公路' : '' }}
                </span>
              </el-form-item>
            </el-col>
            <el-col :span='12'>
              <el-form-item label='物流属性：'>
                <span>
                  {{ item.logisticsAttribute === 1 ? '民生' : item.logisticsAttribute === 0 ? '非民生' : ''
                  }}
                </span>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div-border>

      <div-border label='操作信息'>
        <div
          style='width: 90%;margin: 0 auto;'>
          <el-table
            row-key='id'
            :data='form.operateRecordList'
            border
            class='mt20 mb20'
            :header-cell-style='headerCellStyle'>
            <el-table-column prop='createTime' label='操作时间' align='center' />
            <el-table-column prop='operateType' label='操作类型' align='center' />
            <el-table-column prop='operationName' label='操作人' align='center' />
            <el-table-column prop='remark' label='备注' align='center' />
          </el-table>
        </div>
      </div-border>

      <div class='flex-center-center mt10 mb20'>
        <el-button size='medium' class='searchBtn' @click='dialogClose'>确认</el-button>
        <el-button size='medium' class='resetBtn' @click='dialogClose'>关闭</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
  import { monthlySummaryMonthDetails } from '@/service/financial';
  import divBorder from '@/components/divBorder.vue';

  export default {
    name: 'monthInfo',
    components: { divBorder },
    data() {
      return {
        dialogTitle: '详情',
        dialogVisible: false,
        defaultForm: {},
        form: {},
        formLoading: false,
        headerCellStyle: {
          'color': '#3B3B3B',
          'font-size': '13px',
          'height': '48px',
          'background': '#E8E8E8',
        },
      };
    },
    mounted() {
      this.defaultForm = JSON.parse(JSON.stringify(this.form));
    },
    methods: {
      dialogOpen(id) {
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
        this.getDetails(id);
        this.dialogVisible = true;
      },
      dialogClose() {
        this.dialogVisible = false;
      },
      async getDetails(id) {
        this.formLoading = true;
        const {
          status,
          message,
          data,
        } = await monthlySummaryMonthDetails(id);
        this.formLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.form = data;
      },
    },
  };
</script>

<style lang='scss' scoped>
  .settlement-form {
    width: 80%;
    margin: 0 auto;
  }

  .el-date-editor.el-input, .el-select--mini {
    width: 100%;
  }

  .team {

    &Add {
      display: flex;
      align-items: center;
      margin: 20px 0;

      .add {
        width: 20px !important;
        height: 20px;
        padding-bottom: 3px;
        background-color: #999;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 30px;
        margin-right: 15px;

        &:hover {
          cursor: pointer;
        }
      }

      span {
        font-size: 14px;
        color: #606266;
        font-weight: 700;
      }
    }

    &Item {
      display: flex;
      align-items: center;
      color: #999;
      font-size: 14px;
      margin-top: 10px;
      padding-bottom: 10px;

      span {
        margin-left: 5px;
        color: #606266;
        font-weight: 700;
      }

      border-bottom: 1px solid #CBCBCB;
    }
  }

  .yang {
    margin-top: 10px;
    border-bottom: 1px solid #cbcbcb;

    .el-form-item {

      margin-bottom: 15px;

      .el-form-item__label {
        //width: 150px !important;
        /*color: #060606;*/
      }

      .el-input {
        width: 100%;
      }

      .el-textarea {
        width: 100%;

      }
    }

  }
</style>
